export class State {
  protected machine: StateMachine | undefined;
  enter: () => void = () => {};
  exit: () => void = () => {};
  react: (it: StateMachine) => void = () => {};

  bind(machine: StateMachine) {
    this.machine = machine;
  }

  onEnter(action: () => void = () => {}): State {
    this.enter = action;
    return this;
  }

  onExit(action: () => void = () => {}): State {
    this.exit = action;
    return this;
  }

  onReact(reaction: (it: StateMachine) => void = () => {}): State {
    this.react = reaction;
    return this;
  }
}

export class Event {
  type: string;
  args: unknown[];
}

export class StateMachine {
  protected initial: State;
  protected current: State;
  protected events: Event[] = [];
  protected event: Event;

  constructor(initial: State) {
    this.initial = initial;
  }

  raise(type: string, ...args: unknown[]) {
    this.events.push({ type: type, args: args });
    this.process();
  }

  protected process(): void {
    while (this.events.length > 0) {
      this.event = this.events.shift();
      this.react();
      this.event = null;
    }
  }

  on(type: string): boolean {
    return this.event && this.event.type === type;
  }

  enter() {
    this.current = this.initial;
    this.current.enter();
    this.react();
  }

  activate(state: State) {
    this.current.exit();
    this.current = state;
    state.bind(this);
    this.current.enter();
    this.react(); // do super step
  }

  react() {
    this.current.react(this);
  }
}
